import React from 'react';
import { css } from 'aphrodite/no-important';
import { Button } from '@trainline/depot-web';
import { FormattedMessage } from 'react-intl';

import Menu from '@contactcentre-web/common/Menu';

import styles from './styles';
import messages from './messages';

// @TODO add status as a prop with either Active | Blocked
// Might need to ping Product to check if blocked reason should be included
const ProfileStatus = () => (
  <div className={css(styles.profileStatusContainer)}>
    <div className={css(styles.statusContainer)}>
      <div className={css(styles.statusTitle)}>
        <FormattedMessage {...messages.profile} />:
      </div>
      <div className={css(styles.statusText)}>
        <FormattedMessage {...messages.active} />
      </div>
    </div>
    <div>
      <Menu
        handle={<Button text="..." size="small" buttonType="tertiary" />}
        items={[
          {
            handle: (
              <div className={css(styles.menuItem)}>
                <FormattedMessage {...messages.blockProfile} />
              </div>
            ),
            onClick: () => alert('Block profile clicked'),
          },
          {
            handle: (
              <div className={css(styles.menuItem)}>
                <FormattedMessage {...messages.emailDispute} />
              </div>
            ),
            onClick: () => alert('Email dispute instructions clicked'),
          },
        ]}
      />
    </div>
  </div>
);

export default ProfileStatus;
